// extracted by mini-css-extract-plugin
export default {"sms-communication-consent":"SmsCommunicationConsent-module__sms-communication-consent___3K2AT"};